export default function validateEmail(email) {
  const mailformat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValid = mailformat.test(email);

  return {
    isValid,
    message: isValid ? "" : "You have entered an invalid email address.",
  };
}
